import { useEffect, useMemo, useState } from "react";
import DataTable, { TableStyles } from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { Tree } from "primereact/tree";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Helpers from "../../../../../utils/helpers";
import GridPanel from "./grid-panel";

interface ColumnDef {
  header?: string;
  body?: any;
  name?: any;
  cell?: any;
  selector?: any;
  sortable?: boolean;
  style?: any;
  width?: any;
}
const dataTableStyles: TableStyles = {
  subHeader: {
    style: {
      paddingLeft: "0",
      paddingRight: "0",
    },
  },
  head: {
    style: {
      height: "38px",
      opacity: "1",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#e5e5e5",
      borderTop: "1px solid rgba(0,0,0,0.07)",
      /* borderLeft: "1px solid rgba(0,0,0,0.07)",
        "&:last-of-type": {
          borderRight: "1px solid rgba(0,0,0,0.07)",
        }, */
      justifyContent: "space-between",
      fontWeight: "bold",
      paddingLeft: "12px",
      height: "38px",
      opacity: "1",
    },
  },
  cells: {
    style: {
      /* borderLeft: "1px solid rgba(0,0,0,0.07)",
        "&:last-of-type": {
          borderRight: "1px solid rgba(0,0,0,0.07)",
        }, */
      background: "transparent",
      borderBottom: "#D0D0CE",
      paddingLeft: "13px",
      paddingRight: "13px",
      minHeight: "38px",
    },
  },
};

const Table = (props: any) => {
  const [displayBasic, setDisplayBasic] = useState(false);
  const [headerNameDialogbox, setHeaderNameDialogbox] = useState("");
  const [TreeData, setTreeData] = useState<any>([]);
  const { t } = useTranslation();
  const [tableData, setTableData] = useState<any>([]);
  const [filterText, setFilterText] = useState<any>("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  useEffect(() => {
    if (props?.filteredValues?.length > 0) {
      let CalculatedFilteredValues: any = props?.filteredValues;

      CalculatedFilteredValues.map((table_vals: any) => {
        const sum = table_vals?.obs_sequence_targets?.reduce(
          (a: number, b: number) => a + b
        );
        table_vals.totalTarget = sum;
      });
      setTableData(CalculatedFilteredValues);
    }
  }, [props]);
  const handelDialogbox = (rowData: any) => {
    let SiteName = rowData.siteName;
    let RouteName = rowData.routeName;
    let obs_object: any = [];
    let display_target_x = 1;
    rowData.obs_sequence_targets.forEach((val: any, ind: any) => {
      let temp_target_obj = [];
      for (let x = 1; x <= val; x++) {
        temp_target_obj.push({
          key: Helpers.generateRandomNumber(10000, 99999),
          label: "Target " + display_target_x++,
          data: "Target Data",
          icon: "fa fa-map-pin",
        });
      }
      obs_object.push({
        key: Helpers.generateRandomNumber(10000, 99999),
        label: "observation " + ++ind,
        data: "Observation Data",
        icon: "fa fa-sitemap",
        children: temp_target_obj,
      });
    });
    let master_tree = [
      {
        key: "sitekey",
        label: SiteName,
        data: "Site Data",
        icon: "fa fa-map-marker",
        children: [
          {
            key: "routekey",
            label: RouteName,
            data: "Route Data",
            icon: "fa fa-random",
            children: obs_object,
          },
        ],
      },
    ];
    setTreeData(master_tree);
    setHeaderNameDialogbox(rowData.routeName);
    setDisplayBasic(true);
  };
  const columns: ColumnDef[] = [
    {
      name: "Route Name",
      selector: (row: any) => row.routeName,
      cell: (row: any) => {
        return <>{row.routeName}</>;
      },
      sortable: true,
      // width: '11%'
    },
    {
      name: "Site Name",
      selector: (row: any) => row.siteName,
      cell: (row: any) => {
        return <>{row.siteName}</>;
      },
      sortable: true,
      // width: '11%'
    },
    {
      name: "Camera Operator",
      selector: (row: any) => row.cameraOperator,
      cell: (row: any) => {
        return <>{row.cameraOperator}</>;
      },
      sortable: true,
      // width: '11%'
    },
    {
      name: "Customer",
      selector: (row: any) => row.customer,
      cell: (row: any) => {
        return <>{row.customer}</>;
      },
      sortable: true,
      // width: '11%'
    },
    {
      name: "Total Observations",
      selector: (row: any) => row.total_observations,
      cell: (row: any) => {
        return <>{row.total_observations}</>;
      },
      sortable: true,
      // width: '11%'
    },
    {
      name: "Total Targets",
      selector: (row: any) => row.totalTarget,
      cell: (row: any) => {
        return <>{row.totalTarget}</>;
      },
      sortable: true,
      // width: '11%'
    },

    {
      name: "",
      cell: (row: any) => {
        return (
          <>
            <Button
              onClick={() => {
                // setHeaderNameDialogbox
                handelDialogbox(row);
              }}
            >
              View Detail
            </Button>
          </>
        );
      },
      sortable: true,
      // width: '11%'
    },
  ];

  const liveData = tableData?.length > 0 ? tableData : [];
  // const filteredItems = liveData;
  const filteredItems = liveData?.filter((item: any) => {
    let temp_route_name = item?.routeName;
    let temp_site_name = item?.siteName;
    let temp_cameraOperator = item?.cameraOperator;
    let temp_customer = item?.customer;

    if( temp_route_name == undefined || temp_route_name == null){
      temp_route_name = "";
    }

    if( temp_site_name == undefined || temp_site_name == null){
      temp_site_name = "";
    }

    if( temp_cameraOperator == undefined || temp_cameraOperator == null){
      temp_cameraOperator = "";
    }

    if( temp_customer == undefined || temp_customer == null){
      temp_customer = "";
    }


    let regex = /"(\\.|[^"\\])*"/g;
    var exactMatchText: any =
      filterText != null
        ? filterText.match(regex)?.[0].replace(/"/g, "")
        : null;
    if (exactMatchText) {
      return (
        temp_route_name?.toString().toLowerCase() ==
          filterText?.toLowerCase() ||
          temp_site_name?.toString().toLowerCase() == filterText?.toLowerCase() ||
          temp_cameraOperator?.toString().toLowerCase() ==
          filterText?.toLowerCase() ||
          temp_customer?.toString().toLowerCase() == filterText?.toLowerCase()
      );
    } else {
      return (
        temp_route_name
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
          temp_site_name
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
          temp_cameraOperator
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
          temp_customer
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase())
      );
    }
  });

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      // <FilterComponent onFilter={(e: any) => setFilterText(e?.target?.value)} onClear={handleClear} filterText={filterText} />
      <div className="col-md-12" style={{ marginBottom: "10px" }}>
        <div
          className="d-flex flex-row  justify-content-start align-items-center table-search"
          style={{ maxWidth: "400px" }}
        >
          <label className="custom_common_label">
            {t("SearchLabel")}: &nbsp;&nbsp;&nbsp;{" "}
          </label>
          <div className="inputGroup">
            <div className="input-block">
              <input
                type="text"
                name="sitebulkuploadsearch"
                id="sitebulkuploadsearch"
                className="form-control input-sm"
                onChange={(e: any) => setFilterText(e?.target?.value)}
                value={filterText}
              />
              <span className="material-symbols-outlined">search</span>
            </div>
            <div className="searchClear">
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => handleClear()}
              >
                {" "}
                X
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  const onHide = (name: any) => {
    setDisplayBasic(false);
  };

  const renderFooter = (name: any) => {
    return (
      <div>
        <Button
          label="No"
          icon="pi pi-times"
          onClick={() => onHide(name)}
          className="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          onClick={() => onHide(name)}
          autoFocus
        />
      </div>
    );
  };

  return (
    <>
      {props.isGrid && props.isGrid ? (
        <div className="grid-block" id="grid-block">
          <div className="row">
            <GridPanel
              filteredItems={liveData}
              handelDialogbox={handelDialogbox}
            />
          </div>
        </div>
      ) : (
        <div className="table-responsive" id="table-block">
          <DataTable
            columns={columns}
            data={filteredItems}
            highlightOnHover={true}
            pagination={true}
            subHeader
            subHeaderComponent={
              liveData?.length > 0 ? subHeaderComponentMemo : []
            }
            responsive={true}
            striped={true}
            className={"cusTableRes"}
            // paginationPerPage={5}
            // paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
            customStyles={dataTableStyles}
            // sortIcon={sortIcon}
          />
        </div>
      )}
      
      <Dialog
        header={headerNameDialogbox}
        visible={displayBasic}
        style={{ width: "50vw" }}
        // footer={renderFooter("displayBasic")}
        onHide={() => onHide("displayBasic")}
      >
        <Tree
          value={TreeData}
          expandedKeys={{ routekey: true, sitekey: true }}
          className="w-full md:w-30rem"
        />
      </Dialog>
    </>
  );
};

export default Table;
